import { useAppDispatch, useAppSelector } from '~/store/hooks'
import { deleteSelectedObjects } from '~/store/selectedObjects'
import { Button } from '~/ui/Button'
import { Icon } from '~/ui/Icon'

export const DeleteSelectedObjectsButton = () => {
  const isDisabled = useAppSelector(state => !state.selectedObjects.length)
  const dispatch = useAppDispatch()
  return (
    <Button variant="toolbelt" isDisabled={isDisabled} onPress={() => dispatch(deleteSelectedObjects())}>
      <Icon name="trash" />
      Delete
    </Button>
  )
}
